import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import { Grid, Card, AppBar, Tabs, Tab } from '@mui/material'
import { handleFireflySendEvent } from '../Utils/FireFlyVnextHelpers'
import RdPinDataTab from './RdPinData/RdPinDataTab'
import TransactionTrackerTab from './TransactionTracker/TransactionTrackerTab'
import QuickLinksTab from './QuickLinks/QuickLinksTab'
import HardwareLogFormTab from '../Procurement/HardwareLogForm/HardwareLogFormTab'
import PoLogReportTab from './PoLogReport/PoLogReportTab'
import InventoryCheckerTab from './InventoryChecker/InventoryCheckerTab'

export class Procurement extends React.Component {
  constructor(props) {
    super(props)
    this.availableTabs = [
      {
        name: 'Quick Links',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
      {
        name: 'R&D PIN Inventory',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-PROCUREMENT'],
      },
      {
        name: 'R&D PIN Transactions',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-PROCUREMENT'],
      },
      {
        name: 'Supplemental Form',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
      {
        name: 'PO Log Report',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-PROCUREMENT'],
      },
      {
        name: 'Inventory Checker',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
    ]
    this.state = {
      authorizedTabs: [],
      loading: true,
      selectedTab: 0,
    }
    this.handleTabChange = this.handleTabChange.bind(this)
    this.dialogBox = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Procurement',
        'Procurement Page Load',
        userInfo,
      )
    }
    const authorizedTabs = this.availableTabs.filter(function (tab) {
      return (
        tab.requiredAdGroups.filter((group) =>
          userInfo.memberOf.includes(group),
        ).length > 0 || tab.requiredAdGroups.length === 0
      )
    })
    this.setState({
      authorizedTabs: authorizedTabs,
      loading: false,
      selectedTab: authorizedTabs[0].name,
    })
  }

  handleTabChange(event, newTab) {
    this.setState({
      selectedTab: newTab,
    })
  }

  render() {
    const { classes, userInfo } = this.props

    let tabLabels = []
    this.state.authorizedTabs.forEach((tab) => {
      let tabLabel = <Tab key={tab.name} label={tab.name} value={tab.name} />
      tabLabels.push(tabLabel)
    })

    return (
      <div>
        <HeaderTitle title="Procurement" />
        <Grid item size={{ xs: 12 }}>
          <Card>
            <AppBar position="static">
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                {tabLabels}
              </Tabs>
            </AppBar>
            {this.state.selectedTab === 'Quick Links' &&
              userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                <QuickLinksTab classes={classes} />
              )}
            {this.state.selectedTab === 'R&D PIN Inventory' &&
              (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                userInfo.memberOf.includes(
                  'APP-OAUTH2-ZIPTIE-PROCUREMENT',
                )) && (
                <RdPinDataTab
                  classes={classes}
                  isActive={this.state.selectedTab === 'R&D PIN Inventory'}
                />
              )}
            {this.state.selectedTab === 'R&D PIN Transactions' &&
              (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                userInfo.memberOf.includes(
                  'APP-OAUTH2-ZIPTIE-PROCUREMENT',
                )) && (
                <TransactionTrackerTab
                  classes={classes}
                  isActive={this.state.selectedTab === 'R&D PIN Transactions'}
                />
              )}
            {this.state.selectedTab === 'Supplemental Form' &&
              userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                <HardwareLogFormTab classes={classes} />
              )}
            {this.state.selectedTab === 'PO Log Report' &&
              (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                userInfo.memberOf.includes(
                  'APP-OAUTH2-ZIPTIE-PROCUREMENT',
                )) && (
                <PoLogReportTab
                  classes={classes}
                  isActive={this.state.selectedTab === 'PO Log Report'}
                />
              )}
            {this.state.selectedTab === 'Inventory Checker' &&
              userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                <InventoryCheckerTab classes={classes} />
              )}
          </Card>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Procurement)
